var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3937 9.55233L10.2937 0.545799C9.95259 0.165723 9.29739 0.165723 8.95629 0.545799L0.856285 9.55233C0.739696 9.68166 0.663168 9.8421 0.636005 10.0141C0.608843 10.1862 0.632217 10.3624 0.703285 10.5214C0.847285 10.8466 1.16949 11.0555 1.52499 11.0555H3.32499V17.3601C3.32499 17.599 3.41981 17.828 3.58859 17.9969C3.75737 18.1659 3.98629 18.2607 4.22499 18.2607H6.92499C7.16368 18.2607 7.3926 18.1659 7.56138 17.9969C7.73016 17.828 7.82499 17.599 7.82499 17.3601V13.7575H11.425V17.3601C11.425 17.599 11.5198 17.828 11.6886 17.9969C11.8574 18.1659 12.0863 18.2607 12.325 18.2607H15.025C15.2637 18.2607 15.4926 18.1659 15.6614 17.9969C15.8302 17.828 15.925 17.599 15.925 17.3601V11.0555H17.725C17.8993 11.0563 18.07 11.0062 18.2164 10.9115C18.3628 10.8169 18.4785 10.6816 18.5494 10.5222C18.6203 10.3629 18.6433 10.1863 18.6156 10.0141C18.588 9.8419 18.5109 9.68145 18.3937 9.55233Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a300765ce6627a2bb854bfec997bcca4.svg";
export { ForwardRef as ReactComponent };